<div class="component-container flex flex-col justify-center items-center gap-y-[5rem]">
  <div
    *ngFor="let eachGroup of userDetails['groups']"
    class="each-adult-block flex flex-col justify-center items-center"
  >
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Group Name
        </div>

        <div class="value w-3/5">
          {{ eachGroup['groupName'] }}
        </div>

      </div>

      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Group Start Date and Time
        </div>

        <div class="value w-3/5">
          {{ eachGroup['groupStart'] | date :'medium' }}
        </div>

      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Group Status
        </div>

        <div class="value w-3/5">
          {{ eachGroup['groupStatus']?.value }}
        </div>

      </div>
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Participant Group Status
        </div>

        <div class="value w-3/5">
          {{ eachGroup['participantGroupStatus']?.value }}
        </div>

      </div>
    </div>
  </div>
</div>
